<template>
  <div class="product-warehouse-page w-full">
    <!-- 1. 顶部Banner（精准控温控湿） -->
    <section class="hidden md:block relative w-full overflow-hidden">
      <img src="@/assets/product/Group 24.jpg" alt="精准控温控湿" class="w-full h-full object-cover" />
      <div class="absolute inset-0 text-center top-[20%] text-white z-10">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">
          精准控温控湿
        </h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)] max-w-lg text-center px-4 mx-auto">
          价值主张：打造「人少、高产、质优」的现代化智慧农业生产新模式。
        </p>
      </div>
    </section>
    <section class="block md:hidden relative w-full overflow-hidden h-[80vh]">
      <!-- 背景图 -->
      <img src="@/assets/product/mb_bg1.png" class="absolute inset-0 w-[100%] h-[100%]" alt="" />
      <!-- 深色遮罩提升文字可读性 -->
      <div class="absolute inset-0 bg-black/15"></div>

      <div class="relative z-10 w-full pt-[20%] px-6 flex flex-col items-center text-white">
        <img src="@/assets/logo_H.png" alt="菌丰生物" class="mb-6">
        <!-- 主标题 -->
        <h2 class="text-[24px] font-bold mb-2 text-center">精准控温控湿</h2>
        <!-- 描述文字 -->
        <p class="text-[10px] leading-6 text-center opacity-90 mb-10">
          价值主张：打造「人少、高产、质优」的现代化智慧农业生产新模式。
        </p>
      </div>
      <!-- 底部两个按钮卡片 -->
      <div class="w-full grid grid-cols-2 gap-2 absolute bottom-0 left-0 z-10">
        <div style="background-color: rgba(255, 255, 255, 0.35)" @click="goPage('/product/2')"
          class="bg-opacity-35 py-4 pl-4 flex justify-between items-center text-white">
          <div>
            <p class="text-sm font-medium">蘑菇仓</p>
            <p class="text-[8px] whitespace-nowrap">Mushroom Growing Chamber</p>
          </div>
          <span class="text-xl mr-2">→</span>
        </div>
        <div style="background-color: rgba(255, 255, 255, 0.35)" @click="goPage('/product/1')"
          class="bg-opacity-35 py-4 pl-4 flex justify-between items-center text-white">
          <div>
            <p class="text-sm font-medium">菌菇</p>
            <p class="text-[8px]">Mushroom</p>
          </div>
          <span class="text-xl mr-2">→</span>
        </div>
      </div>
    </section>

    <!-- 2. JF-A系列智能化仿生仓 -->
    <section class="md:py-20 py-10 md:max-w-[56%] max-w-[94%] mx-auto px-4">
      <h2 class="md:block hidden text-3xl font-bold text-[#41B56F] text-center mb-4">
        JF-A 系列智能化立体仿生仓
      </h2>
      <p class="md:block hidden text-[#666] text-center max-w-3xl mx-auto mb-12 leading-relaxed">
        通过模拟自然生态环境，打破传统农业对气候与地域的依赖，<br />
        实现菌菇生产的工业化、可控化与高效化 —— 现代农业智慧转型的核心载体。
      </p>

      <div class="md:hidden text-[24px] font-bold text-[#333] mb-7 text-center">
        <img class="w-[18px] h-[18px]" src="@/assets/home/mb_icon.png" alt="" />
        <div class="mt-2">智能仿生蘑菇仓</div>
      </div>

      <div class="md:flex mx-auto md:px-14 md:py-12 group">
        <div class="md:w-1/2">
          <img src="@/assets/home/Rectangle_11.png" alt="JF-A培养仓"
            class="mx-auto w-[100%] scale-[0.9] group-hover:scale-[1.1]" />
        </div>
        <div class="md:w-1/2 md:pl-8 md:pt-8">
          <div class="md:text-[32px] text-[16px] font-bold text-black mb-7 md:text-left text-center">
            JF-A系列智能化仿生仓
          </div>
          <p class="text-[#666] text-[12px] md:text-[16px] mb-8 max-w-2xl mx-auto md:text-left text-center">
            采用先进传感与自动控制技术，实现菌菇生长环境全自动化管理，
            大幅提升产量与品质，降低运营成本。
          </p>
          <div
            class="mt-8 text-white md:w-[150px] md:h-[30px] w-[80px] h-[20px] mx-auto md:ml-0 text-center bg-[#41B56F] leading-[1.8] md:text-[16px] text-[12px]"
            @click="goDetail(1)">
            了解更多
          </div>
        </div>
      </div>
    </section>

    <!-- 3. 全程可视，风险可控，品质可溯 -->
    <section class="md:py-16 md:max-w-[56%] max-w-[94%] mx-auto px-4">
      <h2 class="md:block hidden text-3xl font-bold text-[#41B56F] text-center mb-4">
        全程可视，风险可控，品质可溯
      </h2>
      <p class="md:block hidden text-[#666] text-center mx-auto mb-12 leading-relaxed text-base">
        24小时智能监控，让种植全程透明可控。实时采集温度、光照、CO₂等关键数据，异常秒级预警，风险不过夜；<br />
        历史数据沉淀，辅助科学决策，告别经验种植；全程电子档案，一键扫码溯源，为品质背书。一人轻松管理多仓，降本增效，开启智慧菌业新范式。
      </p>

      <div class="md:block hidden">
        <div class="grid-box grid grid-cols-4 gap-8 justify-items-center md:py-12">
          <!-- 1 实时监控 -->
          <div class="flex flex-col items-center">
            <div class="relative mb-6">
              <div class="bg-white">
                <div
                  class="rounded-2xl border border-gray-200 border-solid px-3 md:py-6 py-4 text-center relative z-10">
                  <h3 class="text-[#41B56F] md:text-xl text-[8px] font-bold mb-1">
                    高度集成化
                  </h3>
                  <p class="text-gray-500 md:text-sm text-[4px]">
                    单仓全能环境管理
                  </p>
                </div>
                <div class="triangle"></div>
              </div>
            </div>
            <img src="@/assets/product/11_3.png" alt="实时监控" class="object-contain md:w-[160px] w-[58px] h-auto" />
          </div>

          <!-- 2 智能预警 -->
          <div class="flex flex-col items-center">
            <div class="relative mb-6">
              <div class="bg-white">
                <div
                  class="rounded-2xl border border-gray-200 border-solid px-3 md:py-6 py-4 text-center relative z-10">
                  <h3 class="text-[#41B56F] md:text-xl text-[8px] font-bold mb-1">
                    AI 智能调控
                  </h3>
                  <p class="text-gray-500 md:text-sm text-[4px]">
                    自动调节温湿光气
                  </p>
                </div>
                <div class="triangle"></div>
              </div>
            </div>
            <img src="@/assets/product/15_1.png" alt="智能预警" class="object-contain md:w-[160px] w-[58px] h-auto" />
          </div>

          <!-- 3 数据决策 -->
          <div class="flex flex-col items-center">
            <div class="relative mb-6">
              <div class="bg-white">
                <div
                  class="rounded-2xl border border-gray-200 border-solid px-3 md:py-6 py-4 text-center relative z-10">
                  <h3 class="text-[#41B56F] md:text-xl text-[8px] font-bold mb-1">
                    标准化部署
                  </h3>
                  <p class="text-gray-500 md:text-sm text-[4px]">
                    模块化设计，快速组装与异地复制
                  </p>
                </div>
                <div class="triangle"></div>
              </div>
            </div>
            <img src="@/assets/product/12_1.png" alt="数据可视化" class="object-contain md:w-[160px] w-[58px] h-auto" />
          </div>

          <!-- 4 全程溯源 -->
          <div class="flex flex-col items-center">
            <div class="relative mb-6">
              <div class="bg-white">
                <div
                  class="rounded-2xl border border-gray-200 border-solid px-3 md:py-6 py-4 text-center relative z-10">
                  <h3 class="text-[#41B56F] md:text-xl text-[8px] font-bold mb-1">
                    工业级稳定
                  </h3>
                  <p class="text-gray-500 md:text-sm text-[4px]">
                    工业级标准，电源与控制双重冗余
                  </p>
                </div>
                <div class="triangle"></div>
              </div>
            </div>
            <img src="@/assets/product/13_2.png" alt="全链路溯源" class="object-contain md:w-[160px] w-[58px] h-auto" />
          </div>
        </div>
      </div>

      <div class="md:hidden block">
        <div class="grid grid-cols-4 gap-8 justify-items-center md:py-12">
          <!-- 1 实时监控 -->
          <div class="flex flex-col items-center">
            <div class="relative mb-6">
              <div class="">
                <div
                  class="rounded-2xl border border-gray-200 border-solid px-3 md:py-6 py-4 text-center relative z-10">
                  <h3 class="text-[#41B56F] md:text-xl text-[8px] font-bold mb-1">
                    高度集成化
                  </h3>
                  <p class="text-gray-500 md:text-sm text-[4px]">
                    单仓全能环境管理
                  </p>
                </div>
                <div class="triangle"></div>
              </div>
            </div>
            <img src="@/assets/product/11_3.png" alt="实时监控" class="object-containmd: w-[160px] w-[58px] h-auto" />
          </div>

          <!-- 2 智能预警 -->
          <div class="flex flex-col items-center">
            <div class="relative mb-6">
              <div class="">
                <div
                  class="rounded-2xl border border-gray-200 border-solid px-3 md:py-6 py-4 text-center relative z-10">
                  <h3 class="text-[#41B56F] md:text-xl text-[8px] font-bold mb-1">
                    AI 智能调控
                  </h3>
                  <p class="text-gray-500 md:text-sm text-[4px]">
                    自动调节温湿光气
                  </p>
                </div>
                <div class="triangle"></div>
              </div>
            </div>
            <img src="@/assets/product/15_1.png" alt="智能预警" class="object-containmd: w-[160px] w-[58px] h-auto" />
          </div>

          <!-- 3 数据决策 -->
          <div class="flex flex-col items-center">
            <div class="relative mb-6">
              <div class="">
                <div
                  class="rounded-2xl border border-gray-200 border-solid px-3 md:py-6 py-4 text-center relative z-10">
                  <h3 class="text-[#41B56F] md:text-xl text-[8px] font-bold mb-1">
                    标准化部署
                  </h3>
                  <p class="text-gray-500 md:text-sm text-[4px]">
                    模块化设计，快速组装与异地复制
                  </p>
                </div>
                <div class="triangle"></div>
              </div>
            </div>
            <img src="@/assets/product/12_1.png" alt="数据可视化" class="object-containmd: w-[160px] w-[58px] h-auto" />
          </div>

          <!-- 4 全程溯源 -->
          <div class="flex flex-col items-center">
            <div class="relative mb-6">
              <div class="">
                <div
                  class="rounded-2xl border border-gray-200 border-solid px-3 md:py-6 py-4 text-center relative z-10">
                  <h3 class="text-[#41B56F] md:text-xl text-[8px] font-bold mb-1">
                    工业级稳定
                  </h3>
                  <p class="text-gray-500 md:text-sm text-[4px]">
                    工业级标准，电源与控制双重冗余
                  </p>
                </div>
                <div class="triangle"></div>
              </div>
            </div>
            <img src="@/assets/product/13_2.png" alt="全链路溯源" class="object-containmd: w-[160px] w-[58px] h-auto" />
          </div>
        </div>
      </div>
    </section>

    <!-- 4. 智慧蘑菇仓运营大数据 -->
    <section class="py-16 md:max-w-[56%] max-w-[94%] mx-auto px-4">
      <h3 class="text-3xl font-bold text-[#41B56F] mb-8 md:hidden block">
        智慧蘑菇仓运营大数据
      </h3>
      <div class="md:flex justify-between md:flex-row items-center gap-12 group">
        <img src="@/assets/product/Frame_60.png" alt="智慧蘑菇仓运营大数据"
          class="h-auto rounded transition-all duration-500 shadow-sm group-hover:scale-[1.1] w-[70%] block md:inline-block mx-auto" />
        <div class="w-full md:w-1/2">
          <h3 class="text-3xl font-bold text-[#41B56F] mb-4 md:block hidden">
            智慧蘑菇仓运营大数据
          </h3>
          <ul class="text-[#666] space-y-2 text-base leading-relaxed md:block hidden">
            <li>• 环境精准可控：智能系统实时监测，误差±0.5℃，告别露天吃饭。</li>
            <li>• 周年稳定产出：打破季节限制，365天持续供应，订单农业无忧。</li>
            <li>
              • 品质均一保障：标准化流程，菇形整齐、口感稳定，溢价空间大。
            </li>
            <li>
              • 绿色低碳种植：循环水利用、低能耗设计，符合可持续农业趋势。
            </li>
          </ul>
          <div class="w-full bg-[#f8f8f8] md:hidden block mt-8">
            <div class="grid grid-cols-2 gap-2 justify-items-center">
              <!-- 第1项 -->
              <div class="border-b flex items-center border-gray-200">
                <div class="text-[40px] text-[#e3e3e3] font-bold">01</div>
                <div class="ml-4">
                  <h3 class="text-[12px] font-bold text-gray-800">
                    环境精准可控
                  </h3>
                  <p class="mt-2 text-gray-500 text-[10px]">智能系统实时监测</p>
                </div>
              </div>
              <!-- 第2项 -->
              <div class="border-b flex items-center border-gray-200">
                <div class="text-[40px] text-[#e3e3e3] font-bold">02</div>
                <div class="ml-4">
                  <h3 class="text-[12px] font-bold text-gray-800">
                    周年稳定产出
                  </h3>
                  <p class="mt-2 text-gray-500 text-[10px]">打破季节限制</p>
                </div>
              </div>
              <!-- 第3项 -->
              <div class="border-b flex items-center border-gray-200">
                <div class="text-[40px] text-[#e3e3e3] font-bold">03</div>
                <div class="ml-4">
                  <h3 class="text-[12px] font-bold text-gray-800">
                    品质均一保障
                  </h3>
                  <p class="mt-2 text-gray-500 text-[10px]">智能系统实时监测</p>
                </div>
              </div>
              <!-- 第4项 -->
              <div class="border-b flex items-center">
                <div class="text-[40px] text-[#e3e3e3] font-bold">04</div>
                <div class="ml-4">
                  <h3 class="text-[12px] font-bold text-gray-800">
                    绿色低碳种植
                  </h3>
                  <p class="mt-2 text-gray-500 text-[10px]">符合可持续农业趋势</p>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="mt-8 text-white w-[150px] h-[30px] text-center bg-[#41B56F] leading-[1.8]">了解更多</div> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Product2Detail",
  methods: {
    goDetail(id) {
      this.$router.push(`/product2/detail?id=${id}`);
    },

    goPage(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
/* 基础过渡效果 */
/* 小三角 */
.triangle {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 14px;
  height: 14px;
  background: white;
  border-right: 2px solid #e5e7eb;
  border-bottom: 2px solid #e5e7eb;
  z-index: 11;
}

/* 轮流闪烁动画 */
.grid-box>div:nth-child(1) .bg-white {
  animation: blink 4s infinite 0s;
}

.grid-box>div:nth-child(2) .bg-white {
  animation: blink 4s infinite 1s;
}

.grid-box>div:nth-child(3) .bg-white {
  animation: blink 4s infinite 2s;
}

.grid-box>div:nth-child(4) .bg-white {
  animation: blink 4s infinite 3s;
}

.bg-white {
  opacity: 0.2;
  transition: opacity 0.2s ease;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  25% {
    opacity: 1;
  }

  26% {
    opacity: 0.2;
  }

  100% {
    opacity: 0.2;
  }
}
</style>